import Select from "react-select";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import "./selectInput.css";

const SelectInput = ({
  formData,
  handleChange,
  options_data,
  className,
  name,
  default_placeholder,
  label,
  error,
  disabled = false,
  maxMenuHeight = 200,
}) => {
  const translate = useLanguageTranslate();

  // Ensure options_data is always an array to prevent react-select errors
  const safeOptionsData = options_data || [];

  // For nationality fields, we need to match by code since that's what we store
  const isNationalityField = name?.toLowerCase().includes("nationality");

  const selectedOption = safeOptionsData.find((option) => {
    if (isNationalityField) {
      const storedValue = formData?.[name];
      // Try to match by code (numeric) - this is the new format
      if (option.code === storedValue) {
        return true;
      }
      // Fallback: match by value (string) for backward compatibility with old data
      // This handles cases where "BAHRAINI" or "CAMBODIAN" was stored instead of code
      if (typeof storedValue === "string" && option.value === storedValue) {
        return true;
      }
      return false;
    }
    // Match by value for other fields
    return option.value === formData?.[name];
  });

  const handleSelectChange = (selectedOption) => {
    // For nationality fields, store the code (numeric) instead of value (string)
    // This is because the API expects nationality code (e.g., 33 for CAMBODIAN)
    const valueToStore = isNationalityField
      ? selectedOption?.code || ""
      : selectedOption?.value || "";

    if (isNationalityField && selectedOption) {
      console.log(`[SelectInput] Nationality selected:`, {
        label: selectedOption.label,
        code: selectedOption.code,
        storingValue: valueToStore,
      });
    }

    handleChange({
      target: {
        name,
        value: valueToStore,
      },
    });
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: "#DDE2E4",
      borderRadius: "10px",
      padding: "6px",
      minHeight: "42px",
      boxShadow: state.isFocused ? "0 0 0 1px #DDE2E4" : "none",
      "&:hover": {
        borderColor: "#DDE2E4",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f0f8ff" : "white",
      color: "black",
      fontSize: "18px",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "18px",
      color: "black",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6b7280",
      fontSize: "18px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 10000,
  }),
  };

  return (
    <div className={`formField form-input !mb-0 flex-1 ${className}`}>
      {label && (
        <label className="block mb-1 text-[#48535B] not-italic font-normal leading-6 text-base max-350:text-[13px]">
          {label}
        </label>
      )}
      <Select
        options={safeOptionsData}
        value={selectedOption}
        onChange={handleSelectChange}
        placeholder={default_placeholder || translate("Select", "اختر")}
        isSearchable={true}
        isDisabled={disabled}
        styles={customStyles}
        className="!text-black max-h-[200px]"
        maxMenuHeight={maxMenuHeight}
      menuPlacement="auto"
      menuPosition="fixed"
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      />
      {error && <p className="field-err text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default SelectInput;
